import { convertProperty } from '@namphuongtechnologi/utils';

import type { CreateResMiddleWare } from '..';

/**
 * @example
 *
 *  export const exampleResMiddleWare = ResMiddleWare.create<{
 *   contentTypes?: string[];
 *  }>({
 *      handler: (response, options) => {
 *       const { contentTypes } = options || {};
 *
 *       if (contentTypes?.includes(response.headers['content-type'])) {
 *          return {
 *              ...response,
 *              data: override(data), // override data
 *          };
 *       }
 *
 *       return response;
 *      },
 *  });
 */
const create: CreateResMiddleWare = (params) => {
  const { handler } = params;

  return (options) => (onFulfilled) => (response) => onFulfilled(handler(response, options));
};

const convertCamelCase = create<{
  contentTypes?: string[];
}>({
  handler: (response, options) => {
    const { contentTypes } = options || {};

    if (contentTypes?.includes(response.headers['content-type'])) {
      return {
        ...response,
        data: convertProperty(response.data).toCamelCase(),
      };
    }

    return response;
  },
});

export const ResMiddleWare = {
  create,
  convertCamelCase,
};
